import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { FormBaseComponent } from '../forms/form-base/form-base.component';
import { IFormConfig } from '../forms/form.types';

export interface IFilterDialogData {
  filterFields: FormlyFieldConfig[];
  filterValues: any;
  actions: {
    onSubmit: (formModel: any) => any;
    onReset: () => void;
  };
}

@Component({
  selector: 'app-filter-dialog',
  templateUrl: './filter-dialog.component.html',
  imports: [FormBaseComponent],
})
export class FilterDialogComponent {
  formConfig: IFormConfig;

  constructor(
    public dialogRef: MatDialogRef<FilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IFilterDialogData,
    private translateService: TranslateService
  ) {
    this.formConfig = {
      card: {
        header: {
          title: {
            label: '',
          },
        },
        footer: {
          button1: {
            label: this.translateService.instant('table.apply_filters'),
            disabled: false,
            type: 'submit',
            onClick: () => {},
          },
          button2: {
            label: this.translateService.instant('table.reset_filters'),
            disabled: false,
            type: 'reset',
            onClick: () => {
              this.data.actions.onReset();
              this.resetFilter();
            },
          },
        },
      },
      formFields: data.filterFields,
      formModel: data.filterValues,
      options: {},
      title: 'Filter',
    };
  }

  onFormSubmitted(value) {
    this.data.actions.onSubmit(value);
    this.dialogRef.close();
  }

  resetFilter() {
    this.formConfig.formModel = {};
    if (this.formConfig.options?.resetModel) {
      this.formConfig.options.resetModel();
    }
  }
}
